function getQueryStringParameters() {
    var parameters = {}, hash;
    var q = document.URL.split('?')[1];
    if(q != undefined) {
        q = q.split('&');
        for(var i = 0; i < q.length; i++) {
            hash = q[i].split('=');
            parameters[hash[0]] = hash[1];
        }
    }
    return parameters;
}

function isEmpty(obj) {
  for(var key in obj) {
  if(obj.hasOwnProperty(key))
  return false;
  }
  return true;
 }
 
/// Takes a list of query parmeters and a FormData,
/// and appends the parameters to the form
function populateCartAttributes(parameters, formData) {
    if(isEmpty(parameters) == false) {
        const entries = Object.entries(parameters);
        let data = entries.map( ([key, val] = entry) => {
          // apend these to the cart attributes
          // janky, solve at root!
          val = val.replace(/%2F/gi, "/");
          formData.append('attributes[' +key + ']', val)
        });
      }
      return formData
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName;

    for (let i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

 /// Remove attributes from the cart
async function clearCartAndCheckout(config) {
   
    const promise1 = $.ajax({
        type: "GET",
        url: '/cart.js',
        dataType: 'json',
        success: function(resp) {
            var nullHash = {};
            for ([key, value] of Object.entries(resp.attributes)) {    
                nullHash[key] = null;
            }
            $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: {attributes:nullHash},
                dataType: 'json'
            });
        }
      }); 

        const promise2 = fetch('/cart/clear.json', {
          method: "POST",
          headers: {
            "Accept": "application/json"
          }
        });

        Promise.all([promise1, promise2]).then((_) => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else {
                // default localization does not need to be in URL
                if (Shopify.locale != 'en') {
                  window.location.href = "/"+Shopify.locale+"/cart"
                  return
                }
                
                window.location.href = "/cart"
                return
              }
            })
            .catch((e) => {
              console.error(e);
            })
        });                  
}

// Adds a product to the users basket
function addItemToBasket(variantID, quantityToAdd) {
  if (parseInt(quantityToAdd, 10) != NaN) {
    quantityToAdd = parseInt(quantityToAdd, 10);
  }
  else {
    quantityToAdd = 1;
  }

  let datesValid = checkDates(variantID);

  if (datesValid) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
  
    let formData = new FormData();
    formData.append('quantity', quantityToAdd);
    formData.append('form_type', 'product');
    formData.append('id', variantID);
    
    // get any query string parameters, are we topping up an existing iccid?
    let parameters = {};
    // parameters.depart = document.getElementById('bundle-search-depart').value;
    // parameters.return = document.getElementById('bundle-search-return').value;   

    if (sessionStorage.getItem('topUpIccid')) {
      parameters.iccid = sessionStorage.getItem('topUpIccid');
      sessionStorage.removeItem('topUpIccid');
    }

    // populate attributes from utils fn
    formData = populateCartAttributes(parameters, formData);
  
    config.body = formData;
    
    clearCartAndCheckout(config);  
  }
  else {
    let addToCartButtonElem = document.getElementById('bundle-search-add-to-cart');
    let newCartButton = addToCartButtonElem.cloneNode(true);

    addToCartButtonElem.parentNode.replaceChild(newCartButton, addToCartButtonElem);

    let createdAddCartElem = document.getElementById('bundle-search-add-to-cart');
    createdAddCartElem.addEventListener('click', function() {
      addItemToBasket(variantID, quantityToAdd);
    });
    openBundleSearch(true);
  }
}

function checkDates() {
  let departValid = false;
  let returnValid = false;

  if (document.getElementById('bundle-search-depart')) {
    if (document.getElementById('bundle-search-depart').value) {
      returnValid = true;
    }
  }
  else {
    departValid = true;
  }

  if (document.getElementById('bundle-search-return')) {
    if (document.getElementById('bundle-search-return').value) {
      returnValid = true;
    }
  }
  else {
    returnValid = true;
  }

  return departValid && returnValid;
}